import React from 'react';
import { FlameIcon, MoonIcon, ActivityIcon, SunriseIcon, LeafIcon } from 'lucide-react';
import { pains } from '../data/content';
import { SectionTitle } from './SectionTitle';
import { Reveal } from './Reveal';
const icons = [FlameIcon, MoonIcon, ActivityIcon, SunriseIcon, LeafIcon];
export function PainSection() {
  return <section className="bg-botanic px-5 py-10" data-id="element-94" data-mp="2yyfqy855ngba">
      <SectionTitle data-id="element-95" data-mp="2l8ce27s60yyi">¿Te pasa alguna de estas situaciones?</SectionTitle>

      <ul className="mt-6 space-y-3" data-id="element-96" data-mp="2l715zvrot51l">
        {pains.map((pain, i) => {
        const Icon = icons[i];
        return <li key={pain} data-id="element-97" data-mp="2q0vpoz7alk0o" data-mpi={i}>
              <Reveal delay={i * 90} data-id="element-98" data-mp="2baogzb737fd6">
                <div className="flex items-start gap-4 rounded-xl border-l-[3px] border-gold bg-gold/[0.07] px-5 py-5" data-id="element-99" data-mp="2bbr6pfsobbri">
                  <Icon aria-hidden="true" className="mt-0.5 h-6 w-6 shrink-0 text-gold" strokeWidth={1.6} data-id="element-100" data-mp="2g76j03b18zlt" />
                  <p className="font-sans text-[16px] leading-relaxed text-ivory" data-id="element-101" data-mp="22bucyzrffmpl">
                    {pain}
                  </p>
                </div>
              </Reveal>
            </li>;
      })}
      </ul>
    </section>;
}